// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1TJEt","container":"styles_container__uM6Kw","title":"styles_title__1ssZD","wrapper":"styles_wrapper__POqlG","answer":"styles_answer__3mQUy"};